import { render, staticRenderFns } from "./Squadre.vue?vue&type=template&id=0cb17e3d&"
import script from "./Squadre.vue?vue&type=script&lang=js&"
export * from "./Squadre.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports